<template>
    <div class="timeVideo-container">
        <headline :params="headLines" :showListTitle="showListTitle"></headline>
        <div class="timeVideo-content">
            <div v-if="channelList.length == 0" class="empty">
                <img src="../assets/img/timeVideo/empty.png" alt="">
                <p>「时移回看」功能暂不可用请联系管理员</p>
            </div>
            <div v-if="channelList.length > 0" class="left-container">
                <!-- <div class="logo"></div> -->
                <p class="title">时移回看</p>
                <ul>
                    <li v-for="(item,index) in channelList" :key="item.id" @click="channelIndex = index" :class="{on: channelIndex == index}">{{item.name}}</li>
                </ul>
            </div>
            <div v-if="!showLive" :style="'font-size:100px'" class="schedule-container">
                <div class="schedule-content">
                    <ul class="l weekList">
                        <li :class="{on: weekIndex == item.w, un: item.type == 'un'}" @click="changeWeekIndex(item,index)" v-for="(item,index) in week" :key="index">
                            <p>{{ item.week }}</p>
                            <p>{{item.date}}</p>
                        </li>
                    </ul>
                    <div @click="dateDomClick" class="r">
                        <i></i>
                        <span>查询往期</span>
                        <el-date-picker
                            ref="dateDom"
                            v-model="date"
                            value-format="yyyy-MM-dd"
                            type="date"
                            :picker-options="pickerOptions"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                    
                </div>
                <div class="table-content">
                    <ul class="head">
                        <li class="time">直播时间</li>
                        <li class="column">节目</li>
                        <li class="status">状态</li>
                    </ul>
                    <ul class="content">
                        <li :class="{on: item.type == 'live', un: item.type == 'next'}" v-for="(item,index) in programsList" @click="jumpNewVideo(channelIndex,index)" :key="item.id">
                            <div class="time">{{item.start_time}}</div>
                            <div class="column">{{item.name}}</div>
                            <div class="status"><i></i><span>{{item.type == 'prev' ? '可回看' : item.type == 'live' ? '直播中' : '未开始'}}</span></div>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="showLive && channelList.length > 0" :style="'font-size:'+fontSize+'px'" class="right-container">
                <div class="btn-container">
                    <p @click="jumpOutList">
                        <i></i>
                        查看节目单
                    </p>
                </div>

                <div class="video-container">
                    <video autoplay ref="miniVideo"></video>
                    <div class="progress-container">
                        <div v-if="isTime" class="top-container">
                            <div class="l">
                                <p>{{lineWeek}}</p>
                                <p>{{lineDate}}</p>
                            </div>
                            <div ref="videoLine" class="r">
                                <div @mouseout="leftTouchEnd" @mousedown="leftTouchStart" @mouseup="leftTouchEnd"  @click="screenLeft" class="left"></div>
                                <div @mouseout="rightTouchEnd" @mousedown="rightTouchStart" @mouseup="rightTouchEnd" @click="screenRight" class="right"></div>
                                <div style="width: 100%;background: transparent;z-index: 6;background: rgba(255,255,255,0.2)" @click.self="clickLineWidth($event);" class="line"></div>
                                <div v-if="stopPre"  @click.self="clickLineWidth($event);" :style="'width:'+sStep+'em'" class="line">
                                    <!-- <i @mouseenter.prevent="isLineMouseClick=false" @mouseout.prevent="isLineMouseClick=false;" @mousedown.prevent="isLineMouseClick=true;" @mouseup.prevent="isLineMouseClick=false;" @mousemove.prevent="slideLineMouseMove"></i> -->
                                    <!-- <i></i> -->
                                </div>
                                <div v-else  @click.self="clickLineWidth($event);" :style="'width:'+nowStep+'em'" class="line">
                                    <i v-show="nowStep > 0" @mouseenter.prevent="isLineMouseClick=false" @mouseout.prevent="isLineMouseClick=false;" @mousedown.prevent="isLineMouseClick=true;" @mouseup.prevent="isLineMouseClick=false;" @mousemove.prevent="slideLineMouseMove">
                                        <span>{{timeTitle}}</span>
                                    </i>
                                    <!-- <i></i> -->
                                </div>
                                <div v-if="!fullToday && programsList.length > 0" :style="'transform: translateX(-'+nowTimeProgress+'em)'" class="t">
                                    <ul>
                                        <li :style="'width:'+item.width+'em'" :class="{live: item.type == 'live',on: item.nowPlay&&!stopPre&&item.type != 'next',next: item.type == 'next'}" v-for="(item,index) in programsList" :key="item.id" :title="item.name" @click="stopPre=false;startVideo(item,index)"><i></i><span>{{item.name}}</span></li>
                                    </ul>
                                </div>
                                <div v-if="!fullToday && programsList.length == 0" class="t">
                                    <ul style="width: 100%">
                                        <li :style="'width: 100%'"><span>当前暂无节目单</span></li>
                                    </ul>
                                </div>
                                <div v-if="fullToday" class="t">
                                    <ul style="width: 100%">
                                        <li style="width: 100%" class="live on"><i></i><span>全天直播</span></li>
                                    </ul>
                                </div>
                                <div :style="'transform: translateX(-'+nowTimeProgress+'em)'" class="b">
                                   <ul>
                                        <li class="bWidth" v-for="(item,index) in timeLine" :key="index">
                                            <span>{{item.name}}</span>
                                        </li>
                                   </ul>
                                </div>
                            </div>
                        </div>
                        <div :class="{'bottom-container': true, live: !isTime}">
                            <div class="l">
                                <i @click="screenPlay" :class="{pause: isPlay}"></i>
                            </div>
                            <div class="r">
                                <div v-show="isToday && !isLive" @click="toLive" class="word"><span>返回直播</span></div>
                                <div class="time">
                                    <p>时移</p>
                                    <div @click="isTime = !isTime" :class="{un: !isTime}">
                                        <i></i>
                                    </div>
                                </div>
                                <div v-click-outside="closeShowVoice" class="vol">
                                    <i @click="showVoice = !showVoice"></i>
                                    <div v-show="showVoice" class="volContent">
                                        <div ref="volLine" class="line">
                                            <p @click="isVolMouseClick=true;clickJumpHeight($event)" class="lineProgress"></p>
                                            <p @click="isVolMouseClick=true;clickJumpHeight($event)" :style="'height:' + volPercent" class="lineCover">
                                                <i @mouseenter.prevent="isVolMouseClick=false" @mouseout.prevent="isVolMouseClick=false;" @mousedown.prevent="isVolMouseClick=true;" @mouseup.prevent="isVolMouseClick=false;" @mousemove.prevent="slideVolMouseMove"></i>
                                            </p>
                                        </div>
                                        <p>{{volTop}}%</p>
                                    </div>
                                </div>
                                <div @click="fullScreen" class="large"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headline from "@components/videoHeadline";
import Hls from "hls.js";
import vClickOutside from "v-click-outside";
import common from "../common/common";
import {apis} from "../common/config";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        headline
    },
    watch: {
        isFull(to) {
            console.log(to)
            if(to){
                setTimeout(() => {
                    let w = document.querySelectorAll('.progress-container .top-container .r')[0].getBoundingClientRect().width;
                    let bW = document.getElementsByClassName('bWidth')[0].getBoundingClientRect().width;
                    this.calcNum = Math.floor(w / bW)
                }, 500);
            }else{
                this.calcNum = 3
            }
        },
        isLineMouseClick(to) {
            console.log(to,this.isOffTime)
            if(!to && this.isOffTime){
                this.isOffTime = false;
                this.isLive = false;
                if(this.$refs.miniVideo){
                    this.$refs.miniVideo.pause()
                    if(this.hls){
                        this.hls.destroy();
                        this.hls = null;
                    }
                    this.hls = new Hls()
                    this.hls.attachMedia(this.$refs.miniVideo);
                    if(this.isToday){
                        this.hls.loadSource(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+this.offTime * 1000)
                    }else{
                        if(this.$route.query.d){
                            let to = new Date(this.$route.query.d)
                            let from = new Date(this.nowadays)
                            let s = from - to
                            console.log(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+(this.offTime * 1000 + s))
                            this.hls.loadSource(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+(this.offTime * 1000 + s))
                            // console.log(from-to)
                        }
                    }
                    this.slideCountTime()
                    this.slideTimeInterval = setInterval(() => {
                        this.slideCountTime()
                    }, 1000);
                }
            }
        },
        // isClickLine(to) {
        //     console.log(to,this.isOffTime)
        //     if(!to && this.isOffTime){
        //         this.isOffTime = false;
        //         this.isLive = false;
        //         if(this.$refs.miniVideo){
        //             this.$refs.miniVideo.pause()
        //             if(this.hls){
        //                 this.hls.destroy();
        //                 this.hls = null;
        //             }
        //             this.hls = new Hls()
        //             this.hls.attachMedia(this.$refs.miniVideo);
        //             if(this.isToday){
        //                 this.hls.loadSource(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+this.offTime * 1000)
        //             }else{
        //                 if(this.$route.query.d){
        //                     let to = new Date(this.$route.query.d)
        //                     let from = new Date(this.nowadays)
        //                     let s = from - to
        //                     console.log(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+(this.offTime * 1000 + s))
        //                     this.hls.loadSource(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+(this.offTime * 1000 + s))
        //                     // console.log(from-to)
        //                 }
        //             }
        //             this.slideCountTime()
        //             this.slideTimeInterval = setInterval(() => {
        //                 this.slideCountTime()
        //             }, 1000);
        //         }
        //     }
        // },
        channelIndex(to) {
            // console.log(to,this.channelList[to].live_address)
            // this.hls.loadSource(this.channelList[to].live_address)
            this.weekIndex = 999
            if(this.$refs.miniVideo){
                this.$refs.miniVideo.pause()
                this.hls.destroy();
                this.hls = null;
                this.isPlay = false;
                this.hls = new Hls()
                this.hls.attachMedia(this.$refs.miniVideo);
            }
            if(this.showLive){
                this.getPrograms(this.channelList[to].id)
            }else{
                let now = new Date()
                let year = now.getFullYear()
                let month = now.getMonth() + 1
                let day = now.getDate()
                // console.log(now.getDate())
                this.getProgramsWeekList(this.channelList[this.channelIndex].id,year,month,day,true)
                this.getProgramsList(this.channelList[this.channelIndex].id,year,month,day,true)
                
            }
        },
        volTop(to) {
            this.$refs.miniVideo.volume = Number(to)/100
        },
        date(to) {
            // console.log(to)
            this.newTime = to
            let arr = to.split('-')
            if(to == this.nowadays){
                this.getProgramsWeekList(this.channelList[this.channelIndex].id,arr[0],arr[1],arr[2],true)
                this.getProgramsList(this.channelList[this.channelIndex].id,arr[0],arr[1],arr[2],true)
            }else{
                this.getProgramsWeekList(this.channelList[this.channelIndex].id,arr[0],arr[1],arr[2],false)
                this.getProgramsList(this.channelList[this.channelIndex].id,arr[0],arr[1],arr[2],false)
            }
        }
    },
    data() {
        return {
            fullToday: false,
            calcNum: 3,
            timeTitle: '00:00',
            showListTitle: false,
            leftInterval: null,
            rightInterval: null,
            long: false,
            isClickLine: false,
            newTime: '',
            isToday: true,
            slideTimeInterval: null,
            isOffTime: false,
            offTime: 0,
            weekIndex: 0,
            week: [],
            liveIndex: 999,
            pickerOptions: {
            },
            isLive: true,
            isUpdate: true,
            prevTimeIndex: 0,
            savetimeIndex: 0,
            timeIndex: 0,
            programsList: [],
            nowadays: '',
            showLive: true,
            hls: null,
            channelIndex: 0,
            nowStep: 0,
            saveNowStep: 0,
            nowStep1: 10,
            nowTimeProgress: 0,
            showVoice: false,
            isVolMouseClick: false,
            volTop: 50,
            volPercent: "50%",
            showVoiceFull: false,
            isVolMouseClickFull: false,
            isLineMouseClick: false,
            volTopFull: 50,
            volPercentFull: "50%",
            isProgressMouseClick: false,
            progressVal: 0,
            progressPercent: '0%',
            date: null,
            weekHeight: 60,
            isPlay: false,
            isTime: true,
            channelList: [],
            lineDate: '',
            timeLine: [
                {name: '00:00'},
                {name: '00:30'},
                {name: '01:00'},
                {name: '01:30'},
                {name: '02:00'},
                {name: '02:30'},
                {name: '03:00'},
                {name: '03:30'},
                {name: '04:00'},
                {name: '04:30'},
                {name: '05:00'},
                {name: '05:30'},
                {name: '06:00'},
                {name: '06:30'},
                {name: '07:00'},
                {name: '07:30'},
                {name: '08:00'},
                {name: '08:30'},
                {name: '09:00'},
                {name: '09:30'},
                {name: '10:00'},
                {name: '10:30'},
                {name: '11:00'},
                {name: '11:30'},
                {name: '12:00'},
                {name: '12:30'},
                {name: '13:00'},
                {name: '13:30'},
                {name: '14:00'},
                {name: '14:30'},
                {name: '15:00'},
                {name: '15:30'},
                {name: '16:00'},
                {name: '16:30'},
                {name: '17:00'},
                {name: '17:30'},
                {name: '18:00'},
                {name: '18:30'},
                {name: '19:00'},
                {name: '19:30'},
                {name: '20:00'},
                {name: '20:30'},
                {name: '21:00'},
                {name: '21:30'},
                {name: '22:00'},
                {name: '22:30'},
                {name: '23:00'},
                {name: '23:30'},
                {name: '00:00'}
            ],
            headLines: {
                title: "",
                showLink: false,
                filter: false,
                showList: false
            },
            fontSize: 100,
            fontSizeWrite: 100,
            isFull: false,
            nowTimeInterval: null,
            countPrevTimeInterval: null,
            longTimeInterval: null,
            sStep: 0,
            stopPre: false
        }
    },
    methods: {
        formatSeconds(t) {
            let h = parseInt(t / 60 / 60 % 24)
            let m = parseInt(t / 60 % 60)
            let s = parseInt(t % 60)
            //三元表达式 补零 如果小于10 则在前边进行补零 如果大于10 则不需要补零
            h = h < 10 ? '0' + h : h
            m = m < 10 ? '0' + m : m
            s = s < 10 ? '0' + s : s
            /*  if (h < 10 && m < 10 && s < 10) {
                h = m = s = '0'
            } */
            return `${h}:${m}:${s}`
        },
        slideCountTime() {
            let sl = 2.67 / (30*60)
            let sec = this.nowStep + sl

            this.nowStep = sec
            
            let sDate = this.timeLine[this.timeIndex*this.calcNum].name

            sDate = this.time_to_sec(sDate+':00')

            sDate = sDate+this.nowStep/sl

            // console.log(this.formatSeconds(sDate))

            let newS = this.formatSeconds(sDate).split(':')

            this.timeTitle = newS[0] + ':' + newS[1]

            if(this.nowStep > 2.67 * this.calcNum){

                let now = this.timeLine[this.timeIndex*this.calcNum+this.calcNum].name
                now = now.split(':')

                this.timeLine.forEach((el,index) => {
                    if(el.name == now[0]+':'+now[1]){
                        let num = Math.floor(index/this.calcNum) * 2.67 * this.calcNum
                        this.timeIndex = Math.floor(index/this.calcNum)
                        this.prevTimeIndex = Math.floor(index/this.calcNum)
                        this.nowTimeProgress = num
                        this.nowStep = (sDate - this.time_to_sec(el.name+':00')) * sl
                    }
                })
            }

            // let newTitleTime = this.timeLine[this.timeIndex*3].name.split(':')

            // this.timeTitle = Number(newTitleTime[0])+Number(newS[0]) + ':' + Number(newTitleTime[1]) + Number(newS[1])

            // console.log(sDate)

            this.programsList.forEach(el => {
                if(el.start_time_stamp < sDate && sDate < el.end_time_stamp){
                    el.nowPlay = true
                    // this.savetimeIndex = this.timeIndex
                }else{
                    el.nowPlay = false
                }   
            })
            
            // console.log(this.programsList)
        },
        countPrevTime(item,index1,i) {
            let sl = 2.67 / (30*60)

            let date1 = item.end_time.split(':')

            let nowStartTime = this.time_to_sec(this.timeLine[i].name+':00')

            let currentTime = this.time_to_sec(date1[0]+':'+date1[1]+':'+'00')

            if(this.nowStep < ((currentTime - nowStartTime) * sl)){
                this.nowStep = this.nowStep + sl

                let sDate = this.timeLine[this.timeIndex*this.calcNum].name

                sDate = this.time_to_sec(sDate+':00')

                sDate = sDate+this.nowStep/sl

                console.log(this.formatSeconds(sDate))

                let newS = this.formatSeconds(sDate).split(':')

                this.timeTitle = newS[0] + ':' + newS[1]
            }else{
                index1++
                if(index1 == this.liveIndex){
                    clearInterval(this.countPrevTimeInterval)
                    this.countPrevTimeInterval = null;
                    if(this.$refs.miniVideo){
                        this.$refs.miniVideo.pause()
                        this.hls.destroy();
                        this.hls = null;
                    }
                    this.hls = new Hls()
                    this.hls.attachMedia(this.$refs.miniVideo);
                    this.hls.loadSource(this.channelList[this.channelIndex].live_address)
                    this.$refs.miniVideo.play()

                    this.nowTimeInterval = setInterval(() => {
                        this.countTime()
                    }, 1000);
                }else{
                    clearInterval(this.countPrevTimeInterval)
                    this.countPrevTimeInterval = null;
                    if(this.$refs.miniVideo){
                        this.$refs.miniVideo.pause()
                        this.hls.destroy();
                        this.hls = null;
                    }

                    this.startVideo(this.programsList[Number(index1)],index1)
                }
            }
                
        },
        changeWeekIndex(item, index) {
            if(item.type == 'un') return
            // console.log(item.w)
            this.weekIndex = item.w
            this.programsList = item.programs
            this.newTime = item.date
        },
        jumpNewVideo(channelIndex,index) {
            if(this.newTime){
                common.jumpOut("/timeVideo?c="+channelIndex+'&i='+index+'&d='+this.newTime);
            }else{
                common.jumpOut("/timeVideo?c="+channelIndex+'&i='+index+'&d='+this.nowadays);
            }
        },
        jumpOutList() {
            common.jumpOut("/timeVideo?list=true");
        },
        clickShowLive() {
            if(this.slideTimeInterval){
                clearInterval(this.slideTimeInterval)
                this.slideTimeInterval = null
            }

            if(this.countPrevTimeInterval){
                clearInterval(this.countPrevTimeInterval)
                this.countPrevTimeInterval = null
            }

            if(this.nowTimeInterval){
                clearInterval(this.nowTimeInterval)
                this.nowTimeInterval = null
            }

            if(this.$refs.miniVideo){
                this.$refs.miniVideo.pause()
                this.hls.destroy();
                this.hls = null;
            }
            this.showLive = !this.showLive
            if(this.showLive){
                this.showListTitle = false
            }else{
                this.showListTitle = true
            }
            let now = new Date()
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            let day = now.getDate()
            console.log(now.getDate())
            this.getProgramsWeekList(this.channelList[this.channelIndex].id,year,month,day,true)
            this.getProgramsList(this.channelList[this.channelIndex].id,year,month,day,true)

            // this.getProgramsWeekList(this.channelList[this.channelIndex].id,year,month,day,true)
        },
        disabledDate (list) {
            this.pickerOptions = Object.assign({}, this.pickerOptions, {
                disabledDate: (time) => {
                    // console.log(list)
                    let now = new Date()
                    let disable = time.getTime() >= (now - 60 * 60 * 24 * 1000)+( 60 * 60 * 24 * 1000)
                    if(list && list.length > 0){
                        list.forEach(item => {
                            if(item.programs.length == 0){
                                let date = new Date(item.date+' 00:00:00')
                                // console.log(Date.parse(date))
                                // if (time.getTime() == date.getTime()) {
                                //     console.log(999)
                                // }
                                // console.log(time.getTime(),date.getTime())
                                disable = (disable || time.getTime() == date.getTime())
                                // console.log(disable)
                                // disable = disable || time.getTime() > (Number(item.startTime) - 1 * 24 * 60 * 60 * 1000) && time.getTime() < Number(item.endTime)
                            }
                        })
                    }
                    return disable
                }
            })
        },
        screenLeft() {
            if(this.long) return
            console.log('left')
            // if(this.slideTimeInterval){
            //     clearInterval(this.slideTimeInterval)
            //     this.slideTimeInterval = null
            // }

            if(this.countPrevTimeInterval){
                clearInterval(this.countPrevTimeInterval)
                this.countPrevTimeInterval = null
            }

            if(this.nowTimeInterval){
                clearInterval(this.nowTimeInterval)
                this.nowTimeInterval = null
            }
            let num = 0
            if(this.timeIndex > 0){
                num = Number(this.timeIndex) - 1;
                this.timeIndex = num
            }

            if(this.savetimeIndex > this.timeIndex && this.isLive){
                this.nowStep = 100
                this.isUpdate = false;
            }else if(this.savetimeIndex < this.timeIndex && this.isLive){
                this.nowStep = 0
                this.isUpdate = false;
            }else if(this.isLive){
                this.isUpdate = true;
                this.countTime()
                this.nowTimeInterval = setInterval(() => {
                    this.countTime()
                }, 1000);
            }

            if(this.prevTimeIndex > this.timeIndex && !this.isLive){
                this.saveNowStep = this.nowStep
                this.stopPre = true
                this.sStep = 100
            }else if(this.prevTimeIndex < this.timeIndex && !this.isLive){
                this.saveNowStep = this.nowStep
                this.stopPre = true
                this.sStep = 0
            }else if(!this.isLive){
                this.stopPre = false
            }
            
            // else{
            //     this.slideCountTime()
            //     this.slideTimeInterval = setInterval(() => {
            //         this.slideCountTime()
            //     }, 1000);
            // }
            
            this.nowTimeProgress = num * 2.67 * this.calcNum
        },
        screenRight() {
            if(this.long) return
            console.log('right',this.timeIndex,this.savetimeIndex)
            // if(this.slideTimeInterval){
            //     clearInterval(this.slideTimeInterval)
            //     this.slideTimeInterval = null
            // }

            if(this.countPrevTimeInterval){
                clearInterval(this.countPrevTimeInterval)
                this.countPrevTimeInterval = null
            }

            if(this.nowTimeInterval){
                clearInterval(this.nowTimeInterval)
                this.nowTimeInterval = null
            }
            let num = 0
            if(this.timeIndex < 15){
                num = Number(this.timeIndex) + 1;
                this.timeIndex = num
            }else{
                num = 15
            }

            if(this.savetimeIndex > this.timeIndex && this.isLive){
                this.nowStep = 100
                this.isUpdate = false;
            }else if(this.savetimeIndex < this.timeIndex && this.isLive){
                this.nowStep = 0
                this.isUpdate = false;
            }else if(this.isLive){
                this.isUpdate = true;
                this.countTime()
                this.nowTimeInterval = setInterval(() => {
                    this.countTime()
                }, 1000);
            }

            console.log(this.prevTimeIndex,this.timeIndex)

            if(this.prevTimeIndex > this.timeIndex && !this.isLive){
                this.saveNowStep = this.nowStep
                this.stopPre = true
                this.sStep = 100
            }else if(this.prevTimeIndex < this.timeIndex && !this.isLive){
                this.saveNowStep = this.nowStep
                this.stopPre = true
                this.sStep = 0
            }else if(!this.isLive){
                this.stopPre = false
            }
            
            // else{
            //     this.slideCountTime()
            //     this.slideTimeInterval = setInterval(() => {
            //         this.slideCountTime()
            //     }, 1000);
            // }
            
            this.nowTimeProgress = num * 2.67 * this.calcNum
        },
        screenPlay() {
            this.isLive = false;
            this.isPlay = !this.isPlay
            if(this.isPlay){
                this.$refs.miniVideo.play();
                this.slideCountTime()
                this.slideTimeInterval = setInterval(() => {
                    this.slideCountTime()
                }, 1000);
            }else{
                if(this.slideTimeInterval){
                    clearInterval(this.slideTimeInterval)
                    this.slideTimeInterval = null
                }

                if(this.countPrevTimeInterval){
                    clearInterval(this.countPrevTimeInterval)
                    this.countPrevTimeInterval = null
                }

                if(this.nowTimeInterval){
                    clearInterval(this.nowTimeInterval)
                    this.nowTimeInterval = null
                }
                this.$refs.miniVideo.pause();
            }
        },
        getProgramsWeekList(id,year,month,day,nowB) {
            let info = {
                id: id,
                year: year || '',
                month: month || '',
                day: day || ''
            }

            common.myFetch(apis.timevideoprograms, info).then(res => {
                console.log(res)
                let index = 0;
                let date = new Date(year+'-'+month+'-'+day)
                let week = date.getDay()
                // if(date.getDay() == 0){
                //     week = 6
                // }
                
                // else{
                //     week = date.getDay()-1
                // }
                // console.log(week)
                
                res.list.forEach((element,i) => {
                    let w = new Date(element.date).getDay()
                    // if(w == 0){
                    //     w = 6
                    // }
                    // else{
                    //     w = date.getDay()-1
                    // }
                    element.w = w
                    if(element.programs.length == 0){
                        element.type = 'un'
                    }else{
                        element.type = 'normal'
                        index ++
                    }

                    if(element.date == this.nowadays){
                        if(this.nowTimeInterval){
                            clearInterval(this.nowTimeInterval)
                            this.nowTimeInterval = null
                        }

                        // this.nowTimeInterval = setInterval(() => {
                        //     this.countTime()
                        // }, 1000);

                        let date = this.getTruthTime()
                        date = new Date(date)
                        let hour = date.getHours()
                        let minutes = date.getMinutes()
                        let seconds = date.getSeconds()
                        let s = Number(hour*3600) + Number(minutes*60) + Number(seconds)

                        element.programs.forEach((val,key) => {
                            if(s > val.start_time_stamp && s > val.end_time_stamp){
                                val.type = 'prev'
                                val.nowPlay = false
                            }else if(s >= val.start_time_stamp && s < val.end_time_stamp){
                                val.type = 'live'
                                this.liveIndex = Number(key)
                                val.nowPlay = true
                            }else{
                                val.type = 'next'
                                val.nowPlay = false
                            }
                        })

                    }else{
                        if(this.nowTimeInterval){
                            clearInterval(this.nowTimeInterval)
                            this.nowTimeInterval = null
                        }
                        element.programs.forEach(val => {
                            val.type = 'prev'
                            val.nowPlay = false
                        })
                        // console.log(this.programsList)
                    }
                });
                if(index > 0){
                    this.weekIndex = week
                }
                this.week = res.list
            })
        },
        getProgramsList(id,year,month,day,nowB) {
            let info = {
                id: id,
                year: year || '',
                month: month || ''
            }

            common.myFetch(apis.timevideoprograms, info).then(res => {
                console.log(nowB,this.nowadays)
                this.disabledDate(res.list)
                if(month<10){
                    month = '0'+month
                }
                if(day<10){
                    day = '0'+day
                }
                if(res.list.length > 0){
                    res.list.forEach(el => {
                        // console.log(year+'-'+month+'-'+day, this.nowadays)
                        if(year+'-'+month+'-'+day != this.nowadays){
                            console.log(12)
                            if(el.date == year+'-'+month+'-'+day){
                                if(this.nowTimeInterval){
                                    clearInterval(this.nowTimeInterval)
                                    this.nowTimeInterval = null
                                }
                                el.programs.forEach(val => {
                                    val.type = 'prev'
                                    val.nowPlay = false
                                })

                                this.programsList = el.programs
                            }
                            // console.log(this.programsList)
                        }else if(el.date == this.nowadays){
                            console.log(1)
                            if(this.nowTimeInterval){
                                clearInterval(this.nowTimeInterval)
                                this.nowTimeInterval = null
                            }

                            // this.nowTimeInterval = setInterval(() => {
                            //     this.countTime()
                            // }, 1000);

                            let date = this.getTruthTime()
                            date = new Date(date)
                            let hour = date.getHours()
                            let minutes = date.getMinutes()
                            let seconds = date.getSeconds()
                            let s = Number(hour*3600) + Number(minutes*60) + Number(seconds)

                            el.programs.forEach((val,key) => {
                                if(s > val.start_time_stamp && s > val.end_time_stamp){
                                    val.type = 'prev'
                                    val.nowPlay = false
                                }else if(s >= val.start_time_stamp && s < val.end_time_stamp){
                                    val.type = 'live'
                                    this.liveIndex = Number(key)
                                    val.nowPlay = true
                                }else{
                                    val.type = 'next'
                                    val.nowPlay = false
                                }
                            })

                            this.programsList = el.programs
                        }
                    })
                }else{
                    this.programsList = []
                }
            })
        },
        getPrograms(id) {
            let sl = 2.67 / (30*60)

            let info = {
                id: id
            }

            common.myFetch(apis.timevideoprograms, info).then(res => {
                // console.log(res)
                // this.disabledDate(res.list)
                if(res.list.length > 0){
                    if(this.$route.query.d && this.$route.query.d != this.nowadays){
                        res.list.forEach(el => {
                            if(el.date == this.$route.query.d){
                                if(this.slideTimeInterval){
                                    clearInterval(this.slideTimeInterval)
                                    this.slideTimeInterval = null
                                }

                                if(this.countPrevTimeInterval){
                                    clearInterval(this.countPrevTimeInterval)
                                    this.countPrevTimeInterval = null
                                }

                                if(this.nowTimeInterval){
                                    clearInterval(this.nowTimeInterval)
                                    this.nowTimeInterval = null
                                }
                                let sl = 2.67 / (30*60)
                                let date = this.getTruthTime()
                                date = new Date(date)
                                let hour = date.getHours()
                                let minutes = date.getMinutes()
                                let seconds = date.getSeconds()
                                let s = Number(hour*3600) + Number(minutes*60) + Number(seconds)
                                let url = ''
                                let i = 0
                                // console.log(Number(hour*3600) + Number(minutes*60) + Number(seconds))
                                el.programs.forEach(val => {
                                    val.width = Math.abs(((val.end_time_stamp - val.start_time_stamp) * sl) / 0.14)
                                    val.type = 'prev'
                                    val.nowPlay = false
                                })

                                console.log(url)

                                this.programsList = el.programs

                                this.startVideo(this.programsList[Number(this.$route.query.i)],Number(this.$route.query.i))

                                let date1 = this.programsList[Number(this.$route.query.i)].start_time.split(':')

                                let secMin = '00'

                                if(Number(date1[1]) < 30){
                                    secMin = '00'
                                }else{
                                    secMin = '30'
                                }

                                this.timeLine.forEach((el,index) => {
                                    if(el.name == date1[0]+':'+secMin){
                                        let num = Math.floor(index/this.calcNum) * 2.67 * this.calcNum
                                        i = Math.floor(index/this.calcNum) * this.calcNum
                                        this.nowTimeProgress = num
                                    }
                                })
                
                                let nowStartTime = this.time_to_sec(this.timeLine[i].name+':00')

                                let currentTime = this.time_to_sec(date1[0]+':'+date1[1]+':'+'00')

                                this.nowStep = ((currentTime - nowStartTime) * sl)

                            }
                        })
                    }else{
                        res.list.forEach(el => {
                            if(el.date == this.nowadays){
                                let date = this.getTruthTime()
                                date = new Date(date)
                                let hour = date.getHours()
                                let minutes = date.getMinutes()
                                let seconds = date.getSeconds()
                                let s = Number(hour*3600) + Number(minutes*60) + Number(seconds)
                                let url = ''
                                // console.log(Number(hour*3600) + Number(minutes*60) + Number(seconds))
                                el.programs.forEach((val,key) => {
                                    val.width = Math.abs(((val.end_time_stamp - val.start_time_stamp) * sl) / 0.14)
                                    if(s > val.start_time_stamp && s > val.end_time_stamp){
                                        val.type = 'prev'
                                        val.nowPlay = false
                                    }else if(s >= val.start_time_stamp && s < val.end_time_stamp){
                                        val.type = 'live'
                                        this.liveIndex = Number(key)
                                        val.nowPlay = true
                                        url = val.live_address
                                    }else{
                                        val.type = 'next'
                                        val.nowPlay = false
                                    }
                                })

                                console.log(url)

                                this.programsList = el.programs
                                if(this.$refs.miniVideo){
                                    if(this.$route.query.i && this.liveIndex == this.$route.query.i){
                                        this.hls.loadSource(this.channelList[this.channelIndex].live_address)
                                        this.$refs.miniVideo.play()
                                        if(this.nowTimeInterval){
                                            clearInterval(this.nowTimeInterval)
                                            this.nowTimeInterval = null
                                        }

                                        this.nowTimeInterval = setInterval(() => {
                                            this.countTime()
                                        }, 1000);
                                    }else if(this.$route.query.i && this.liveIndex != this.$route.query.i){
                                        this.hls.loadSource(this.programsList[Number(this.$route.query.i)].live_address)
                                        this.$refs.miniVideo.play()
                                        this.isLive = false;
                                        if(this.nowTimeInterval){
                                            clearInterval(this.nowTimeInterval)
                                            this.nowTimeInterval = null
                                        }

                                        if(this.countPrevTimeInterval){
                                            clearInterval(this.countPrevTimeInterval)
                                            this.countPrevTimeInterval = null
                                        }

                                        if(this.slideTimeInterval){
                                            clearInterval(this.slideTimeInterval)
                                            this.slideTimeInterval = null
                                        }

                                        let date1 = this.programsList[Number(this.$route.query.i)].start_time.split(':')

                                        let secMin = '00'

                                        if(Number(date1[1]) < 30){
                                            secMin = '00'
                                        }else{
                                            secMin = '30'
                                        }

                                        this.timeLine.forEach((el,index) => {
                                            if(el.name == date1[0]+':'+secMin){
                                                let num = Math.floor(index/this.calcNum) * 2.67 * this.calcNum
                                                this.timeIndex =  Math.floor(index/this.calcNum)
                                                this.prevTimeIndex = Math.floor(index/this.calcNum)
                                                this.nowTimeProgress = num
                                            }
                                        })

                                        this.slideTimeInterval = setInterval(() => {
                                            this.slideCountTime()
                                        }, 1000);
                                    }else{
                                        this.isLive = true
                                        this.hls.loadSource(this.channelList[this.channelIndex].live_address)
                                        this.$refs.miniVideo.play()
                                        if(this.nowTimeInterval){
                                            clearInterval(this.nowTimeInterval)
                                            this.nowTimeInterval = null
                                        }

                                        this.nowTimeInterval = setInterval(() => {
                                            this.countTime()
                                        }, 1000);
                                    }
                                }
                                // this.$nextTick(() => {
                                //     this.setNowTime()
                                // })
                                
                                // this.hls.loadSource(url)
                                // this.$refs.miniVideo.play()
                            }
                        })
                    }
                }else{
                    this.programsList = []
                    this.hls.loadSource(this.channelList[this.channelIndex].live_address)
                    this.$refs.miniVideo.play()
                    if(this.nowTimeInterval){
                        clearInterval(this.nowTimeInterval)
                        this.nowTimeInterval = null
                    }

                    this.nowTimeInterval = setInterval(() => {
                        this.countTime()
                    }, 1000);
                }

                if(this.programsList.length == 1){
                    this.fullToday = true
                }
            })
        },
        getTimeVideoList() {
            common.myFetch(apis.timevideolist).then(res => {
                console.log(res)
                if(res){
                    this.channelList = res.list

                    if(this.$route.query.list && this.$route.query.list == 'true'){
                        this.clickShowLive()
                    }else{
                        this.$nextTick(() => {
                            if(this.channelList.length > 0){
                                this.hls = new Hls()
                                this.hls.attachMedia(this.$refs.miniVideo);
                                this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                                    console.log("加载成功");
                                    this.$refs.miniVideo.volume = Number(this.volTop)/100
                                });
                                // if(this.$routes.query.)
                                // console.log(this.$route)
                                if(this.$route.query.c){
                                    this.channelIndex = Number(this.$route.query.c)
                                    this.getPrograms(res.list[Number(this.$route.query.c)].id)  
                                }else{
                                    this.getPrograms(res.list[0].id)  
                                }
                                this.$refs.miniVideo.addEventListener('play',() => {
                                    this.isPlay = true;
                                })

                                this.$refs.miniVideo.addEventListener('pause',() => {
                                    this.isPlay = false;
                                })
                            }
                        })
                    }
                }
            })
        },
        getTruthTime () {
            // // 服务器端时区，北京东八区（-8*60）
            // let timezone = -480
            // // 客户端实际时区(例如东京为东九区：-540)
            // let offsetGMT = new Date().getTimezoneOffset()
            // // 计算差值（用户在东京时区下下单，需要补回1小时）
            // let adjust = timezone - offsetGMT
            // // 需要修复的时间，支持字符串传参
            // let nowDate = time ? new Date(time).getTime() : new Date().getTime()
            // 取本地时间
            var localtime = new Date();
            // 取本地毫秒数
            var localmesc = localtime.getTime();
            // 取本地时区与格林尼治所在时区的偏差毫秒数
            var localOffset = localtime.getTimezoneOffset() * 60000;
            // 反推得到格林尼治时间
            var utc = localOffset + localmesc;
            // 得到指定时区时间
            var calctime = utc + (3600000 * 8);

            let timeStamp = new Date(calctime)
            // console.log(timeStamp)
            let year = timeStamp.getFullYear()
            let month = timeStamp.getMonth()
            let day = timeStamp.getDate()
            let hour = timeStamp.getHours()
            let minutes = timeStamp.getMinutes()
            let seconds = timeStamp.getSeconds()
            let date = Date.UTC(year, month, day, hour, minutes, seconds, 0) / 1000 - (8 * 60 * 60)
            date = date * 1000
            // console.log(date)
            return date
        },
        time_to_sec(time) {
            var s = '';

            var hour = time.split(':')[0];
            var min = time.split(':')[1];
            var sec = time.split(':')[2];

            s = Number(hour*3600) + Number(min*60) + Number(sec);

            return s;
        },
        longTime() {
            let date = this.getTruthTime()
            date = new Date(date)
            let hour = date.getHours()
            let minutes = date.getMinutes()
            let secMin = '00'

            if(hour < 10){
                hour = '0'+hour
            }

            if(minutes < 30){
                secMin = '00'
            }else{
                secMin = '30'
            }

            this.timeLine.forEach((el,index) => {
                if(el.name == hour+':'+secMin){
                    this.savetimeIndex =  Math.floor(index/this.calcNum)
                }
            })
        },
        setNowTime() {
            let date = this.getTruthTime()
            date = new Date(date)
            let year = date.getFullYear()
            let month = date.getMonth()+1
            let day = date.getDate()
            let hour = date.getHours()
            let minutes = date.getMinutes()
            let seconds = date.getSeconds()
            let s = Number(hour*3600) + Number(minutes*60) + Number(seconds)
            let secMin = '00'
            let i = 0

            if(year < 10){
                year = '0'+year
            }

            if(month < 10){
                month = '0'+month
            }

            if(day < 10){
                day = '0'+day
            }

            this.nowadays = year+'-'+month+'-'+day

            if(this.$route.query.d && this.nowadays != this.$route.query.d){
                this.isToday = false;
                this.isLive = false;
                this.lineWeek = month+'/'+day
                let weekDate = new Date(this.$route.query.d)
                weekDate = weekDate.getDay()
                if(weekDate == 0){
                    this.lineWeek = '周日'
                }else if(weekDate == 1){
                    this.lineWeek = '周一'
                }else if(weekDate == 2){
                    this.lineWeek = '周二'
                }else if(weekDate == 3){
                    this.lineWeek = '周三'
                }else if(weekDate == 4){
                    this.lineWeek = '周四'
                }else if(weekDate == 5){
                    this.lineWeek = '周五'
                }else if(weekDate == 6){
                    this.lineWeek = '周六'
                }
                let lineDate = this.$route.query.d.split('-')
                this.lineDate = lineDate[1]+'/'+lineDate[2]
            }else{
                this.isToday = true;
                this.isLive = false;
                this.lineWeek = '今日'
                this.lineDate = month+'/'+day
            }

            if(hour < 10){
                hour = '0'+hour
            }

            if(minutes < 30){
                secMin = '00'
            }else{
                secMin = '30'
            }

            if(minutes < 10){
                minutes = '0'+minutes
            }

            if(seconds < 10){
                seconds = '0'+seconds
            }

            this.timeLine.forEach((el,index) => {
                if(s > el.start_time_stamp && s > el.end_time_stamp){
                    el.type = 'prev'
                }else if(s >= el.start_time_stamp && s < el.end_time_stamp){
                    el.type = 'live'
                    // url = el.live_address
                }else{
                    el.type = 'next'
                }
                if(el.name == hour+':'+secMin){
                    let num = Math.floor(index/this.calcNum) * 2.67 * this.calcNum
                    if(this.isUpdate){
                        this.timeIndex =  Math.floor(index/this.calcNum)
                    }
                    if(this.isLive){
                        this.savetimeIndex =  Math.floor(index/this.calcNum)
                    }else{
                        this.timeIndex =  Math.floor(index/this.calcNum)
                        this.prevTimeIndex =  Math.floor(index/this.calcNum)
                    }
                    i = Math.floor(index/this.calcNum) * this.calcNum
                    this.nowTimeProgress = num
                }
            })

            let sl = 2.67 / (30*60)
            
            let nowStartTime = this.time_to_sec(this.timeLine[i].name+':00')

            let currentTime = this.time_to_sec(hour+':'+minutes+':'+seconds)

            this.nowStep = ((currentTime - nowStartTime) * sl)

            if(this.nowTimeInterval){
                clearInterval(this.nowTimeInterval)
                this.nowTimeInterval = null
            }

            if(this.longTimeInterval){
                clearInterval(this.longTimeInterval)
                this.longTimeInterval = null
            }

            this.longTimeInterval = setInterval(() => {
                this.longTime()
            }, 1000);

            if(this.isLive){
                this.nowTimeInterval = setInterval(() => {
                    this.countTime()
                }, 1000);
            }
        },
        countTime() {
            let date = this.getTruthTime()
            date = new Date(date)
            let hour = date.getHours()
            let minutes = date.getMinutes()
            let seconds = date.getSeconds()
            let s = Number(hour*3600) + Number(minutes*60) + Number(seconds)
            let secMin = '00'
            let i = 0

            if(hour < 10){
                hour = '0'+hour
            }

            if(minutes < 30){
                secMin = '00'
            }else{
                secMin = '30'
            }

            if(minutes < 10){
                minutes = '0'+minutes
            }

            if(seconds < 10){
                seconds = '0'+seconds
            }

            this.timeLine.forEach((el,index) => {
                if(this.$route.query.d && this.$route.query.d != this.nowadays){
                    el.type = 'prev'
                    // let num = Math.floor(Number(this.$route.query.i)/3) * 2.67 * 3
                    // this.timeIndex =  Math.floor(Number(this.$route.query.i)/3)
                    // i = Math.floor(Number(this.$route.query.i)/3) * 3
                    // this.nowTimeProgress = num
                }else{
                    if(s > el.start_time_stamp && s > el.end_time_stamp){
                        el.type = 'prev'
                    }else if(s >= el.start_time_stamp && s < el.end_time_stamp){
                        el.type = 'live'
                        // url = el.live_address
                    }else{
                        el.type = 'next'
                    }

                    if(el.name == hour+':'+secMin){
                        let num = Math.floor(index/this.calcNum) * 2.67 * this.calcNum
                        if(this.isUpdate){
                            this.timeIndex =  Math.floor(index/this.calcNum)
                        }
                        this.savetimeIndex =  Math.floor(index/this.calcNum)
                        i = Math.floor(index/this.calcNum) * this.calcNum
                        this.nowTimeProgress = num
                    }
                }
            })

            this.programsList.forEach((val,key) => {
                // val.width = Math.abs(((val.end_time_stamp - val.start_time_stamp) * sl) / 0.14)
                if(this.$route.query.d && this.$route.query.d != this.nowadays){
                    val.type = 'prev'
                }else{
                    if(s > val.start_time_stamp && s > val.end_time_stamp){
                        val.type = 'prev'
                        val.nowPlay = false
                    }else if(s >= val.start_time_stamp && s < val.end_time_stamp){
                        val.type = 'live'
                        this.liveIndex = Number(key)
                        if(this.isLive){
                            val.nowPlay = true
                        }
                    }else{
                        val.type = 'next'
                        val.nowPlay = false
                    }
                }
                
            })

            let sl = 2.67 / (30*60)
            
            let nowStartTime = this.time_to_sec(this.timeLine[i].name+':00')

            let currentTime = this.time_to_sec(hour+':'+minutes+':'+seconds)

            this.timeTitle = hour+':'+minutes

            this.nowStep = ((currentTime - nowStartTime) * sl)

            // console.log(this.nowStep)
        },
        fullScreen() {
            this.isFull = !this.isFull
            if(this.isFull){
                this.requestFullscreen()
            }else{
                this.exitFullScreen()
            }
        },
        requestFullscreen () {
            const docElm = document.getElementsByClassName('video-container')[0]
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen()
            } else if (docElm.msRequestFullscreen) {
                docElm.msRequestFullscreen()
            } else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen()
            } else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen()
            }
        },
        exitFullScreen () {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen()
            }
        },
        closeShowVoice() {
            this.showVoice = false;
        },
        closeShowVoiceFull() {
            this.showVoiceFull = false;
        },
        clickJumpProgress(e) {
            let clientX= this.$refs.videoLine.getBoundingClientRect().x;
            let width = this.$refs.videoLine.getBoundingClientRect().width;
            let top = 0;
            let volPercent = 0;

            if (e.clientX - clientX <= 0) {
                top = "100%";
            } else if (e.clientX - clientX >= this.$refs.videoLine.getBoundingClientRect().width) {
                top = "0%";
            } else {
                volPercent = (100 - (((e.clientX - clientX) / width) * 100).toFixed(2)).toFixed(0);
                top = 100 - (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
            }

            this.progressVal = volPercent;
            this.progressPercent = top;

            // this.$refs.sliderLeft.style.width = left;

            // this.timeNavi();

            this.isProgressMouseClick = false;
        },
        clickJumpHeight(e) {
            let clientY = this.$refs.volLine.getBoundingClientRect().y;
            let height = this.$refs.volLine.getBoundingClientRect().height;
            let top = 0;
            let volPercent = 0;

            if (e.clientY - clientY <= 0) {
                top = "100%";
            } else if (e.clientY - clientY >= this.$refs.volLine.getBoundingClientRect().height) {
                top = "0%";
            } else {
                volPercent = (100 - (((e.clientY - clientY) / height) * 100).toFixed(2)).toFixed(0);
                top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
            }

            this.volTop = volPercent;
            this.volPercent = top;

            // this.$refs.sliderLeft.style.width = left;

            // this.timeNavi();

            this.isVolMouseClick = false;
        },
        clickLineWidth(e) {
            this.isClickLine = true
            this.stopPre = false
            console.log(123,this.isClickLine)
            if(this.slideTimeInterval){
                clearInterval(this.slideTimeInterval)
                this.slideTimeInterval = null
            }

            if(this.countPrevTimeInterval){
                clearInterval(this.countPrevTimeInterval)
                this.countPrevTimeInterval = null
            }

            if(this.nowTimeInterval){
                clearInterval(this.nowTimeInterval)
                this.nowTimeInterval = null
            }
            let sl = 2.67 / (30*60)
            let t = this.$refs.videoLine.getBoundingClientRect().width / this.fontSize / 100
            let clientX = this.$refs.videoLine.getBoundingClientRect().x;
            let width = this.$refs.videoLine.getBoundingClientRect().width;
            let top = 0;
            let volPercent = 0;

            if (e.clientX - clientX <= 0) {
                // top = "100%";
                volPercent = 100 * t
            } else if (e.clientX - clientX >= this.$refs.videoLine.getBoundingClientRect().width) {
                // top = "0%";
                volPercent = 0 * t
            } else {
                volPercent = (((e.clientX - clientX) / width) * 100).toFixed(2) * t;
                // top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
            }

            let date = new Date()

            let nowStartTime = this.time_to_sec(this.timeLine[this.savetimeIndex*this.calcNum].name+':00')

            let currentTime = this.time_to_sec(date.getHours()+':'+date.getMinutes()+':'+date.getSeconds())

            let trueYear = date.getFullYear()

            let trueMonth = date.getMonth()+1

            let trueDay = date.getDate()

            if(trueMonth<10){
                trueMonth = '0'+trueMonth
            }

            if(trueDay<10){
                trueDay = '0'+trueDay
            }

            let sDate = this.timeLine[this.timeIndex*this.calcNum].name

            sDate = this.time_to_sec(sDate+':00')

            let date1 = this.getTruthTime()
            date1 = new Date(date1)
            let hour = date1.getHours()
            let minutes = date1.getMinutes()
            let seconds = date1.getSeconds()

            if(hour < 10){
                hour = '0'+hour
            }

            if(minutes < 10){
                minutes = '0'+minutes
            }

            if(seconds < 10){
                seconds = '0'+seconds
            }

            let eDate = this.time_to_sec(hour+':'+minutes+':'+seconds)

            sDate = sDate+volPercent/sl

            this.offTime = Math.floor(eDate-sDate)
            this.isOffTime = true

            if((this.$route.query.d && this.$route.query.d == this.nowadays) || (!this.$route.query.d && this.nowadays == trueYear+'-'+trueMonth+'-'+trueDay)){
                if((this.isLive && !this.stopPre && (this.nowadays == trueYear+'-'+trueMonth+'-'+trueDay) && volPercent > ((currentTime - nowStartTime) * sl)) || ((this.nowadays == trueYear+'-'+trueMonth+'-'+trueDay) && sDate > currentTime)) return
            }

            this.nowStep = volPercent;

            this.prevTimeIndex = this.timeIndex

            // console.log(this.nowStep)

            // this.$refs.sliderLeft.style.width = left;

            // this.timeNavi();

            this.isClickLine = false;

            this.isOffTime = false;
            this.isLive = false;
            if(this.$refs.miniVideo){
                this.$refs.miniVideo.pause()
                if(this.hls){
                    this.hls.destroy();
                    this.hls = null;
                }
                this.hls = new Hls()
                this.hls.attachMedia(this.$refs.miniVideo);
                if(this.isToday){
                    this.hls.loadSource(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+this.offTime * 1000)
                }else{
                    if(this.$route.query.d){
                        let to = new Date(this.$route.query.d)
                        let from = new Date(this.nowadays)
                        let s = from - to
                        // console.log(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+(this.offTime * 1000 + s))
                        this.hls.loadSource(this.channelList[this.channelIndex].live_address+'?lhs_offset_unix_ms_0='+(this.offTime * 1000 + s))
                        // console.log(from-to)
                    }
                }
                this.slideCountTime()
                this.slideTimeInterval = setInterval(() => {
                    this.slideCountTime()
                }, 1000);
            }
            // console.log(this.isClickLine)
        },
        slideLineMouseMove(e) {
            // return false;
            let sl = 2.67 / (30*60)
            let t = this.$refs.videoLine.getBoundingClientRect().width / this.fontSize / 100
            if (this.isLineMouseClick) {

                if(this.slideTimeInterval){
                    clearInterval(this.slideTimeInterval)
                    this.slideTimeInterval = null
                }

                if(this.countPrevTimeInterval){
                    clearInterval(this.countPrevTimeInterval)
                    this.countPrevTimeInterval = null
                }

                if(this.nowTimeInterval){
                    clearInterval(this.nowTimeInterval)
                    this.nowTimeInterval = null
                }

                let clientX = this.$refs.videoLine.getBoundingClientRect().x;
                let width = this.$refs.videoLine.getBoundingClientRect().width;
                let top = 0;
                let volPercent = 0;
                // console.log(e.clientY - clientY )
                if (e.clientX - clientX <= 0) {
                    // top = "100%";
                    volPercent = 100 * t
                } else if (e.clientX - clientX >= this.$refs.videoLine.getBoundingClientRect().width) {
                    // top = "0%";
                    volPercent = 0 * t
                } else {
                    volPercent = (((e.clientX - clientX) / width) * 100).toFixed(2) * t;
                    // top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
                }

                let date = new Date()

                let nowStartTime = this.time_to_sec(this.timeLine[this.savetimeIndex*this.calcNum].name+':00')

                let currentTime = this.time_to_sec(date.getHours()+':'+date.getMinutes()+':'+date.getSeconds())

                let trueYear = date.getFullYear()

                let trueMonth = date.getMonth()+1

                let trueDay = date.getDate()

                if(trueMonth<10){
                    trueMonth = '0'+trueMonth
                }

                if(trueDay<10){
                    trueDay = '0'+trueDay
                }

                let sDate = this.timeLine[this.timeIndex*this.calcNum].name

                sDate = this.time_to_sec(sDate+':00')

                let date1 = this.getTruthTime()
                date1 = new Date(date1)
                let hour = date1.getHours()
                let minutes = date1.getMinutes()
                let seconds = date1.getSeconds()

                if(hour < 10){
                    hour = '0'+hour
                }

                if(minutes < 10){
                    minutes = '0'+minutes
                }

                if(seconds < 10){
                    seconds = '0'+seconds
                }

                let eDate = this.time_to_sec(hour+':'+minutes+':'+seconds)

                sDate = sDate+volPercent/sl

                // console.log(this.formatSeconds(sDate))

                let newS = this.formatSeconds(sDate).split(':')

                this.timeTitle = newS[0] + ':' + newS[1]

                this.offTime = Math.floor(eDate-sDate)
                this.isOffTime = true

                // console.log(((this.nowadays == trueYear+'-'+trueMonth+'-'+trueDay)))

                if((this.$route.query.d && this.$route.query.d == this.nowadays) || (!this.$route.query.d && this.nowadays == trueYear+'-'+trueMonth+'-'+trueDay)){
                    if((this.isLive && (this.nowadays == trueYear+'-'+trueMonth+'-'+trueDay) && volPercent > ((currentTime - nowStartTime) * sl)) || ((this.nowadays == trueYear+'-'+trueMonth+'-'+trueDay) && sDate > currentTime)) return
                }

                this.nowStep = volPercent;

                // console.log(Math.floor(eDate-sDate))

            }
        },
        slideVolMouseMove(e) {
            // return false;
            if (this.isVolMouseClick) {
                let clientY = this.$refs.volLine.getBoundingClientRect().y;
                let height = this.$refs.volLine.getBoundingClientRect().height;
                let top = 0;
                let volPercent = 0;
                // console.log(e.clientY - clientY )
                if (e.clientY - clientY <= 0) {
                    top = "100%";
                    volPercent = 100
                } else if (e.clientY - clientY >= this.$refs.volLine.getBoundingClientRect().height) {
                    top = "0%";
                    volPercent = 0
                } else {
                    volPercent = (100 - (((e.clientY - clientY) / height) * 100).toFixed(2)).toFixed(0);
                    top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
                }

                // console.log(top)

                this.volTop = volPercent;
                this.volPercent = top;
            }
        },
        clickJumpHeightFull(e) {
            let clientY = this.$refs.volLineFull.getBoundingClientRect().y;
            let height = this.$refs.volLineFull.getBoundingClientRect().height;
            let top = 0;
            let volPercent = 0;

            if (e.clientY - clientY <= 0) {
                top = "100%";
            } else if (e.clientY - clientY >= this.$refs.volLine.getBoundingClientRect().height) {
                top = "0%";
            } else {
                volPercent = (100 - (((e.clientY - clientY) / height) * 100).toFixed(2)).toFixed(0);
                top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
            }

            this.volTopFull = volPercent;
            this.volPercentFull = top;

            // this.$refs.sliderLeft.style.width = left;

            // this.timeNavi();

            this.isVolMouseClickFull = false;
        },
        slideVolMouseMoveFull(e) {
            // return false;
            if (this.isVolMouseClickFull) {
                let clientY = this.$refs.volLineFull.getBoundingClientRect().y;
                let height = this.$refs.volLineFull.getBoundingClientRect().height;
                let top = 0;
                let volPercent = 0;
                // console.log(e.clientY - clientY )
                if (e.clientY - clientY <= 0) {
                    top = "100%";
                    volPercent = 100
                } else if (e.clientY - clientY >= this.$refs.volLineFull.getBoundingClientRect().height) {
                    top = "0%";
                    volPercent = 0
                } else {
                    volPercent = (100 - (((e.clientY - clientY) / height) * 100).toFixed(2)).toFixed(0);
                    top = 100 - (((e.clientY - clientY) / height) * 100).toFixed(2) + "%";
                }

                // console.log(top)

                this.volTopFull = volPercent;
                this.volPercentFull = top;
            }
        },
        dateDomClick() {
            // console.log(this.$refs.dateDom)
            // let dateDom = document.querySelectorAll('.el-date-editor.el-date-editor--date')
            // console.log(dateDom)
            // dateDom.click()
        },
        getHeight() {
            let li = document.querySelectorAll('.weekList li')[0]
            if(li){
                this.weekHeight = li.getBoundingClientRect().width
            }
        },
        recalc() {
            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 1334);

            this.fontSizeWrite = p

            if(p<97.3){
                p=97.3
            }else if(p>110){
                p=110
            }

            this.fontSize = p
        },
        startVideo(item,index1) {
            console.log(item)
            if(item.type && item.type == 'next') return
            this.$refs.miniVideo.pause()
            if(this.hls){
                this.hls.destroy();
                this.hls = null;
            }
            this.isPlay = false;
            let i = 0
            let sl = 2.67 / (30*60)
            if(item.type == 'prev'){
                this.isLive = false;
                if(this.slideTimeInterval){
                    clearInterval(this.slideTimeInterval)
                    this.slideTimeInterval = null
                }

                if(this.countPrevTimeInterval){
                    clearInterval(this.countPrevTimeInterval)
                    this.countPrevTimeInterval = null
                }

                if(this.nowTimeInterval){
                    clearInterval(this.nowTimeInterval)
                    this.nowTimeInterval = null
                }
                if(this.$refs.miniVideo){
                    this.hls = new Hls()
                    this.hls.attachMedia(this.$refs.miniVideo);
                    this.hls.loadSource(item.live_address)
                }
                let date1 = item.start_time.split(':')

                let secMin = '00'

                if(Number(date1[1]) < 30){
                    secMin = '00'
                }else{
                    secMin = '30'
                }

                this.timeLine.forEach((el,index) => {
                    if(el.name == date1[0]+':'+secMin){
                        let num = Math.floor(index/this.calcNum) * 2.67 * this.calcNum
                        this.timeIndex = Math.floor(index/this.calcNum)
                        // console.log(Math.floor(index/3))
                        // this.savetimeIndex = Math.floor(index/3)
                        this.prevTimeIndex = Math.floor(index/this.calcNum)
                        console.log(this.timeIndex,this.prevTimeIndex)
                        i = Math.floor(index/this.calcNum) * this.calcNum
                        this.nowTimeProgress = num
                    }
                })

                let nowStartTime = this.time_to_sec(this.timeLine[i].name+':00')

                let currentTime = this.time_to_sec(date1[0]+':'+date1[1]+':'+'00')

                this.nowStep = ((currentTime - nowStartTime) * sl)

                // if(this.isPlay){
                    // console.log(this.isPlay)
                    this.countPrevTime(item,index1,i)
                    this.countPrevTimeInterval = setInterval(() => {
                        this.countPrevTime(item,index1,i)
                    }, 1000);
                // }

                this.programsList.forEach(el => {
                    if(el.id == item.id){
                        el.nowPlay = true
                    }else{
                        el.nowPlay = false
                    }
                })
            }else if(item.type == 'live'){
                // this.$refs.miniVideo.pause()
                // this.isPlay = false;
                this.isLive = true;
                if(this.nowTimeInterval){
                    clearInterval(this.nowTimeInterval)
                    this.nowTimeInterval = null
                }
                this.nowTimeInterval = setInterval(() => {
                    this.countTime()
                }, 1000);
                if(this.$refs.miniVideo){
                    this.hls = new Hls()
                    this.hls.attachMedia(this.$refs.miniVideo);
                    this.hls.loadSource(this.channelList[this.channelIndex].live_address)
                    // this.$refs.miniVideo.play()
                }
                this.programsList.forEach(el => {
                    if(el.id == item.id){
                        el.nowPlay = true
                    }else{
                        el.nowPlay = false
                    }
                })
            }
        },
        toLive() {
            let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 深拷贝
            delete newQuery.c
            delete newQuery.i
            delete newQuery.d
            this.$router.replace({ query: newQuery })
            this.isLive = true;
            this.stopPre = false;
            this.isUpdate = true
            if(this.slideTimeInterval){
                clearInterval(this.slideTimeInterval)
                this.slideTimeInterval = null
            }

            if(this.countPrevTimeInterval){
                clearInterval(this.countPrevTimeInterval)
                this.countPrevTimeInterval = null
            }

            if(this.nowTimeInterval){
                clearInterval(this.nowTimeInterval)
                this.nowTimeInterval = null
            }
            if(this.$refs.miniVideo){
                this.$refs.miniVideo.pause()
                if(this.hls){
                    this.isPlay = false;
                    this.hls.destroy();
                    this.hls = null;
                }
                this.hls = new Hls()
                this.hls.attachMedia(this.$refs.miniVideo);
                this.hls.loadSource(this.channelList[this.channelIndex].live_address)
                this.$refs.miniVideo.play()
                this.countTime()
                this.nowTimeInterval = setInterval(() => {
                    this.countTime()
                }, 1000);
            }
        },
        leftTouchStart() {
            this.leftInterval = setInterval(() => {
                this.long = true;
                if(this.countPrevTimeInterval){
                    clearInterval(this.countPrevTimeInterval)
                    this.countPrevTimeInterval = null
                }

                if(this.nowTimeInterval){
                    clearInterval(this.nowTimeInterval)
                    this.nowTimeInterval = null
                }
                let num = 0
                if(this.timeIndex > 0){
                    num = Number(this.timeIndex) - 1;
                    this.timeIndex = num
                }

                if(this.savetimeIndex > this.timeIndex && this.isLive){
                    this.nowStep = 100
                    this.isUpdate = false;
                }else if(this.savetimeIndex < this.timeIndex && this.isLive){
                    this.nowStep = 0
                    this.isUpdate = false;
                }else if(this.isLive){
                    this.isUpdate = true;
                    this.countTime()
                    this.nowTimeInterval = setInterval(() => {
                        this.countTime()
                    }, 1000);
                }

                if(this.prevTimeIndex > this.timeIndex && !this.isLive){
                    this.saveNowStep = this.nowStep
                    this.stopPre = true
                    this.sStep = 100
                }else if(this.prevTimeIndex < this.timeIndex && !this.isLive){
                    this.saveNowStep = this.nowStep
                    this.stopPre = true
                    this.sStep = 0
                }else if(!this.isLive){
                    this.stopPre = false
                }
                
                this.nowTimeProgress = num * 2.67 * this.calcNum
            }, 800);
        },
        leftTouchEnd() {
            if(this.leftInterval){
                clearInterval(this.leftInterval)
                this.leftInterval = null;
                setTimeout(() => {
                    this.long = false;
                }, 300);
            }
        },
        rightTouchStart() {
            this.rightInterval = setInterval(() => {
                this.long = true;
                if(this.countPrevTimeInterval){
                    clearInterval(this.countPrevTimeInterval)
                    this.countPrevTimeInterval = null
                }

                if(this.nowTimeInterval){
                    clearInterval(this.nowTimeInterval)
                    this.nowTimeInterval = null
                }
                let num = 0
                if(this.timeIndex < 15){
                    num = Number(this.timeIndex) + 1;
                    this.timeIndex = num
                }else{
                    num = 15
                }

                if(this.savetimeIndex > this.timeIndex && this.isLive){
                    this.nowStep = 100
                    this.isUpdate = false;
                }else if(this.savetimeIndex < this.timeIndex && this.isLive){
                    this.nowStep = 0
                    this.isUpdate = false;
                }else if(this.isLive){
                    this.isUpdate = true;
                    this.countTime()
                    this.nowTimeInterval = setInterval(() => {
                        this.countTime()
                    }, 1000);
                }

                console.log(this.prevTimeIndex,this.timeIndex)

                if(this.prevTimeIndex > this.timeIndex && !this.isLive){
                    this.saveNowStep = this.nowStep
                    this.stopPre = true
                    this.sStep = 100
                }else if(this.prevTimeIndex < this.timeIndex && !this.isLive){
                    this.saveNowStep = this.nowStep
                    this.stopPre = true
                    this.sStep = 0
                }else if(!this.isLive){
                    this.stopPre = false
                }
                
                this.nowTimeProgress = num * 2.67 * this.calcNum
            }, 800);
        },
        rightTouchEnd() {
            if(this.rightInterval){
                clearInterval(this.rightInterval)
                this.rightInterval = null;
                setTimeout(() => {
                    this.long = false;
                }, 300);
            }
        }
    },
    destroy() {
        // document.removeEventListener('fullscreenchange')
        window.removeEventListener('resize')
        if(this.slideTimeInterval){
            clearInterval(this.slideTimeInterval)
            this.slideTimeInterval = null
        }

        if(this.countPrevTimeInterval){
            clearInterval(this.countPrevTimeInterval)
            this.countPrevTimeInterval = null
        }

        if(this.nowTimeInterval){
            clearInterval(this.nowTimeInterval)
            this.nowTimeInterval = null
        }

        if(this.longTimeInterval){
            clearInterval(this.longTimeInterval)
            this.longTimeInterval = null
        }
    },
    mounted() {
        let that = this;

        window.addEventListener('resize', () => {
            if (!checkFull()) {

                let timeVideoContainer = document.getElementsByClassName('timeVideo-container')[0]

                if(timeVideoContainer){
                    // console.log("退出全屏")

                    that.isFull = false;
                }

            }
        })

        this.setNowTime()

        function checkFull() {

            var fullScreen = parent.document.webkitIsFullScreen || parent.document.fullscreen || parent.document.mozFullScreen || parent.document.msFullscreenElement;

            if (fullScreen === undefined) {fullScreen = false;}

            return fullScreen;

        }

        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

        window.addEventListener(resizeEvt, this.recalc, false);

        this.recalc()

        this.getTimeVideoList()
    }
}
</script>

<style lang="less" scoped>
    .timeVideo-container {

        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        background: url('../assets/img/timeVideo/bg.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        overflow-y: hidden;

        .timeVideo-content {
            display: flex;
            flex-direction: row;
            width: 100%;
            height: calc(100vh - 70px);
        }

        .empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;

            img {
                width: 200px;
                height: 132px;
                margin-bottom: 17px;
            }

            p {
                width: 168px;
                font-size: 14px;
                line-height: 21px;
                color: #FFFFFF;
                text-align: center;
            }
        }

        .left-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 248px;
            height: 100%;
            background: rgba(15,19,27,0.29);

            .logo {
                width: 150px;
                height: 30px;
                background: url('../assets/img/timeVideo/logo.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-bottom: 50px;
                margin-top: 20px;
            }

            .title {
                font-size: 22px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 30px;
                margin-bottom: 30px;
                margin-top: 30px;
            }

            ul {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
                flex: 1;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(185, 195, 195, 0.3);
                    border-radius: 4px;
                }

                li {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    width: 168px;
                    min-height: 48px;
                    // line-height: 48px;
                    text-align: center;
                    border-radius: 8px;
                    margin-bottom: 17px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &.on {
                        font-weight: bold;
                        color: #FFFFFF;
                        border: 1px solid #525D59;
                        background: linear-gradient(270deg, #33FFD6 0%, #39E0A4 61%, rgba(130, 255, 126, 0.92) 100%);
                        box-sizing: border-box;
                        text-shadow: 0px 1px 4px rgba(8, 113, 91, 0.8);

                        &::before {
                            display: flex;
                            content: '';
                            width: 26px;
                            height: 26px;
                            background: url('../assets/img/timeVideo/live.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            margin-right: 3px;
                        }
                    }
                }
            }
        }

        .schedule-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            height: 100%;
            padding: 0 0.4em;
            box-sizing: border-box;

            .schedule-content {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 0.6em;
                margin-top: 0.1em;

                .l {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex: 1;

                    li {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        // flex: 1;
                        width: 1em;
                        height: 0.6em;
                        padding: 0 0.15em;
                        border-radius: 0.08em;
                        border: 0.01em solid transparent;
                        box-sizing: border-box;
                        margin-right: 0.3em;

                        &.on {
                            border: 0.01em solid #41B48C;

                            p {
                                color: #41B48C;
                            }
                        }

                        &.un {
                            p {
                                color: rgba(255,255,255,0.5);
                            }
                        }

                        p {
                            font-size: 0.12em;
                            line-height: 1.4167em;
                            color: #FFFFFF;
                            margin-bottom: 0.4167em;

                            &:nth-last-of-type(1) {
                                margin-bottom: 0;
                            }
                        }

                        // &:nth-last-of-type(1) {
                        //     margin-right: 0;
                        // }
                    }
                }

                .r {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    width: 1.2em;
                    height: 0.4em;
                    background: rgba(65, 180, 140, 0.1);
                    border-radius: 20px;
                    border: 0.01em solid #41B48C;
                    box-sizing: border-box;
                    user-select: none;
                    cursor: pointer;

                    .el-date-editor {
                        position: absolute;
                        // z-index: -1;
                        width: 120px;
                        height: 40px;
                        background: transparent !important;
                    }

                    i {
                        display: block;
                        width: 0.18em;
                        height: 0.18em;
                        background: url('../assets/img/timeVideo/old.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 0.1em;
                    }

                    span {
                        font-size: 0.14em;
                        color: #41B48C;
                    }
                }
            }

            .table-content {
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-top: 0.25em;
                height: calc(100vh - 70px - 0.7em - 0.25em);

                .head {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 100%;
                    min-height: 0.38em;
                    background-color: rgba(185,195,195,0.1);

                    .time {
                        width: 25.35%;
                        font-size: 0.14em;
                        font-weight: bold;
                        color: rgba(255,255,255,0.4);
                        padding-left: 8%;
                        box-sizing: border-box;
                    }

                    .column {
                        width: 61.33%;
                        font-size: 0.14em;
                        font-weight: bold;
                        color: rgba(255,255,255,0.4);
                        padding-right: 5%;
                        box-sizing: border-box;
                    }

                    .status {
                        width: 13.32%;
                        font-size: 0.14em;
                        font-weight: bold;
                        color: rgba(255,255,255,0.4);
                    }
                }

                .content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    flex: 1;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: rgba(185, 195, 195, 0.3);
                        border-radius: 4px;
                    }
                    // background-color: rgba(185,195,195,0.1);

                    li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        min-height: 0.6em;
                        color: rgba(255,255,255,1);
                        user-select: none;
                        cursor: pointer;

                        i {
                            display: block;
                            width: 1em;
                            height: 1em;
                            margin-top: 0.125em;
                            margin-right: 0.4375em;
                            background: url('../assets/img/timeVideo/prev.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                        }

                        &.on {
                            background-color: rgba(65,180,140,0.1);
                            color: #41B48C;
                            font-weight: bold;

                            i {
                                display: block;
                                width: 1em;
                                height: 1em;
                                margin-top: 0.125em;
                                margin-right: 0.4375em;
                                background: url('../assets/img/timeVideo/gLive.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                            }
                        }

                        &.un {
                            color: #A6A6A8;

                            i {
                                display: block;
                                width: 1em;
                                height: 1em;
                                margin-top: 0.125em;
                                margin-right: 0.4375em;
                                background: url('../assets/img/timeVideo/unplay.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                            }
                        }

                        &:hover {
                            background-color: rgba(185,195,195,0.1);
                        }
                    }

                    .time {
                        width: 25.35%;
                        font-size: 0.16em;
                        padding-left: 8%;
                        box-sizing: border-box;
                    }

                    .column {
                        width: 61.33%;
                        font-size: 0.16em;
                        padding-right: 5%;
                        box-sizing: border-box;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }

                    .status {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 13.32%;
                        font-size: 0.16em;
                    }
                }
            }
        }

        .right-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            height: 100%;
            padding: 0 0.78em;
            box-sizing: border-box;
            overflow-y: auto;
            overflow-x: hidden;

            &::-webkit-scrollbar {
                width: 4px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(185, 195, 195, 0.3);
                border-radius: 4px;
            }
 
            .btn-container {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                margin-top: 10px;
                margin-bottom: 20px;
                width: 100%;

                p {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    height: 40px;
                    background: rgba(65, 180, 140, 0.1);
                    border-radius: 20px;
                    border: 1px solid #41B48C;
                    padding: 0 18px;
                    box-sizing: border-box;
                    font-size: 14px;
                    color: #41B48C;
                    user-select: none;
                    cursor: pointer;

                    i {
                        display: block;
                        width: 18px;
                        height: 18px;
                        background: url('../assets/img/timeVideo/menu.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 10px;
                    }
                }
            }

            .video-container {
                position: relative;
                display: flex;
                width: 9.28em;
                height: 5.22em;

                video {
                    width: 100%;
                    height: 100%;
                }

                .progress-container {
                    opacity: 0;
                    display: flex;
                    flex-direction: column;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    // height: 1.4em;
                    background: rgba(0, 0, 0, 0.4);
                    // background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(0.05em);

                    &:hover {
                        opacity: 1;
                    }

                    .top-container {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        height: 0.68em;
                        user-select: none;
                        background: rgba(255, 255, 255, 0.1);
                        // backdrop-filter: blur(0.05em);
                        

                        .l {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            width: 0.6em;
                            height: 0.68em;
                            background: rgba(255, 255, 255, 0.1);
                            backdrop-filter: blur(0.1em);

                            p {
                                font-size: 0.16em;
                                line-height: 1.375em;
                                color: #FFFFFF;

                                &:nth-of-type(1) {
                                    margin-bottom: 0.375em;
                                }
                            }
                        }

                        .r {
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            width: calc(100% - 0.6em);
                            height: 100%;
                            overflow-x: clip;

                            &:hover {
                                .left,.right {
                                    display: block
                                }
                            }

                            .t {
                                display: flex;
                                width: 100%;
                                height: 0.64em;
                                // overflow-x: clip;

                                ul {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    height: 0.64em;

                                    li {
                                        position: relative;
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: center;
                                        align-items: center;
                                        // width: 19.143em;
                                        height: 100%;
                                        line-height: 4.5714em;
                                        // text-align: center;
                                        // padding: 0 1.786em;
                                        box-sizing: border-box;
                                        font-size: 0.14em;
                                        color: #FFF;
                                        // padding: 0.5714em 0;
                                        box-sizing: border-box;

                                        &::after {
                                            position: absolute;
                                            top: 0.5714em;
                                            right: 0;
                                            display: block;
                                            content: '';
                                            width: 1px;
                                            height: 3.4286em;
                                            background: rgba(255,255,255,0.3);
                                        }

                                        i {
                                            display: block;
                                            min-width: 1.1429em;
                                            min-height: 1.1429em;
                                            background: url('../assets/img/timeVideo/prev.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            user-select: none;
                                            margin-right: 0.0714em;
                                        }

                                        span {
                                            text-overflow: ellipsis;
                                            overflow: hidden;
                                            white-space: nowrap;
                                        }

                                        &.live {
                                            i {
                                                display: block;
                                                min-width: 1.1429em;
                                                min-height: 1.1429em;
                                                background: url('../assets/img/timeVideo/nowlive.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                                user-select: none;
                                                margin-right: 0.0714em;
                                            }
                                        }

                                        &.next {
                                            i {
                                                display: block;
                                                min-width: 1.1429em;
                                                min-height: 1.1429em;
                                                background: url('../assets/img/timeVideo/unplay.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                                user-select: none;
                                                margin-right: 0.0714em;
                                            }

                                            span {
                                                color: rgba(255,255,255,0.5);
                                            }
                                        }
                                        
                                        &.on {
                                            background: linear-gradient(180deg, rgba(58, 255, 203, 0) 0%, rgba(82, 255, 204, 0.1) 43%, rgba(26, 255, 175, 0.8) 100%);
                                        }
                                    }
                                }
                            }

                            .left {
                                display: none;
                                position: absolute;
                                top: 50%;
                                left: 0.06em;
                                z-index: 99;
                                width: 0.24em;
                                height: 0.24em;
                                margin-top: -0.12em;
                                background: url('../assets/img/timeVideo/left.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }

                            .right {
                                display: none;
                                position: absolute;
                                top: 50%;
                                right: 0.06em;
                                z-index: 99;
                                width: 0.24em;
                                height: 0.24em;
                                margin-top: -0.12em;
                                background: url('../assets/img/timeVideo/right.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }

                            .line {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                width: 100%;
                                height: 0.04em;
                                z-index: 8;
                                background: #41B48C;

                                &>i {
                                    position: absolute;
                                    top: 50%;
                                    right: -0.06em;
                                    z-index: 9;
                                    margin-top: -0.06em;
                                    display: block;
                                    width: 0.12em;
                                    height: 0.12em;
                                    border-radius: 50%;
                                    background: #FFFFFF;
                                    box-shadow: -5px 1px 8px 0px rgba(20, 117, 83, 0.44);
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        span {
                                            display: block;
                                        }
                                    }

                                    span {
                                        display: none;
                                        position: absolute;
                                        top: 1em;
                                        left: 1.2em;
                                        z-index: 99;
                                        color: #FFF;
                                        font-size: 0.12em;
                                    }
                                }
                            }

                            .t {
                                width: 100%;
                                height: 0.64em;
                            }

                            .b {
                                display: flex;
                                width: 100%;
                                height: 0.04em;
                                background: rgba(255,255,255,0.2);
                                // overflow-x: clip;

                                ul {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    transform: translateX(0px);

                                    li {
                                        position: relative;
                                        width: 2.67em;
                                        height: 0.04em;
                                        // background: #41B48C;

                                        span {
                                            position: absolute;
                                            left: 0.462em;
                                            bottom: -1.6154em;
                                            font-size: 0.13em;
                                            color: #FFF;
                                            // font-weight: bold;
                                        }

                                        &::after {
                                            position: absolute;
                                            bottom: -0.18em;
                                            left: 0px;
                                            display: block;
                                            content: '';
                                            width: 1px;
                                            height: 0.18em;
                                            background: rgba(255,255,255,0.3);
                                            cursor: pointer;
                                            // background: red;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .bottom-container {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: flex-end;
                        width: 100%;
                        height: 0.72em;
                        padding: 0 0.24em 0.14em;
                        box-sizing: border-box;
                        user-select: none;
                        background: rgba(255, 255, 255, 0.1);
                        // backdrop-filter: blur(0.05em);

                        &.live {
                            height: 0.52em;
                            padding: 0.14em 0.24em;
                            box-sizing: border-box;
                        }

                        .l {
                            i {
                                display: block;
                                width: 24px;
                                height: 24px;
                                background: url('../assets/img/timeVideo/play.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;

                                &.pause {
                                    display: block;
                                    width: 24px;
                                    height: 24px;
                                    background: url('../assets/img/timeVideo/pause.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        

                        .r {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            .word {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 0.86em;
                                height: 0.26em;
                                text-align: center;
                                background: #41B48C;
                                border-radius: 0.2em;
                                margin-right: 0.4em;
                                user-select: none;
                                cursor: pointer;

                                span {
                                    font-size: 0.14em;
                                    color: #FFF;
                                    font-weight: bold;
                                }
                            }

                            .time {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                margin-right: 0.24em;

                                p {
                                    font-size: 0.14em;
                                    color: #FFF;
                                    line-height: 1.429em;
                                }

                                div {
                                    display: flex;
                                    align-items: center;
                                    width: 0.3em;
                                    height: 0.14em;
                                    background: #41B48C;
                                    border-radius: 0.07em;
                                    margin-left: 0.1em;
                                    user-select: none;
                                    cursor: pointer;

                                    &.un {
                                        background: #CED3D7;

                                        i {
                                        margin-left: 0.01em;
                                        transition: margin-left 0.3s;
                                        }
                                    }

                                    i {
                                        display: block;
                                        width: 0.12em;
                                        height: 0.12em;
                                        background: #FFFFFF;
                                        border-radius: 50%;
                                        margin-left: 0.17em;
                                        transition: margin-left 0.3s;
                                    }
                                }
                            }

                            .vol {
                                position: relative;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 0.24em;
                                height: 0.24em;
                                margin-right: 0.24em;
                                user-select: none;
                                cursor: pointer;

                                // &:hover {
                                //     i {
                                //         display: block !important;
                                //         width: 100%;
                                //         height: 100%;
                                //         background: url('../assets/img/timeVideo/volOn.png') no-repeat;
                                //         background-size: 100% 100%;
                                //         background-position: center center;
                                //     }
                                // }

                                i {
                                    display: block !important;
                                    width: 100%;
                                    height: 100%;
                                    background: url('../assets/img/timeVideo/vol.png') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                }

                                .volContent {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    align-items: center;
                                    position: absolute;
                                    bottom: 0.3em;
                                    left: 50%;
                                    width: 0.42em;
                                    height: 1.48em;
                                    margin-left: -0.21em;
                                    padding: 0.1em 0;
                                    background: #1F2128;
                                    box-shadow: 0.04em 0.04em 0.1em 0px rgba(5, 10, 15, 0.05);
                                    box-sizing: border-box;

                                    .line {
                                        position: relative;
                                        width: 0.02em;
                                        height: 1em;

                                        .lineProgress {
                                            width: 0.02em;
                                            height: 1em;
                                            background: rgba(80, 85, 88, 0.29);
                                            border-radius: 0.05em;
                                        }

                                        .lineCover {
                                            position: absolute;
                                            bottom: 0;
                                            left: 0;
                                            width: 100%;
                                            height: 100%;
                                            background: #41B48C;

                                            i {
                                                position: absolute;
                                                top: -0.04em;
                                                left: -0.05em;
                                                display: block;
                                                width: 0.12em;
                                                height: 0.12em;
                                                border-radius: 50%;
                                                background: #41B48C;
                                                user-select: none;
                                                cursor: pointer;
                                            }
                                        }
                                    }

                                    & > p {
                                        font-size: 0.13em;
                                        font-weight: 500;
                                        color: #FFF;
                                        line-height: 1.3846em;
                                    }

                                    &::after {
                                        position: absolute;
                                        left: 50%;
                                        bottom: -0.06em;
                                        margin-left: -0.05em;
                                        display: block;
                                        content: '';
                                        width: 0;
                                        height: 0;
                                        border-left: 0.06em solid transparent;
                                        border-right: 0.06em solid transparent;
                                        border-top: 0.06em solid #1F2128;
                                    }
                                }
                            }

                            .large {
                                display: block;
                                width: 0.24em;
                                height: 0.24em;
                                background: url('../assets/img/timeVideo/large.png') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                user-select: none;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

        .fullVideo-container {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: #1F2128;
            z-index: 9999;

            video {
                width: 100%;
                height: 100%;
            }

            .progress-container {
                    display: flex;
                    flex-direction: column;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    // height: 1.4em;
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(0.05em);

                    .top-container {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        height: 0.68em;
                        user-select: none;

                        .l {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            width: 0.6em;
                            height: 0.68em;
                            background: rgba(255, 255, 255, 0.1);
                            backdrop-filter: blur(0.1em);

                            p {
                                font-size: 0.16em;
                                line-height: 1.375em;
                                color: #FFFFFF;

                                &:nth-of-type(1) {
                                    margin-bottom: 0.375em;
                                }
                            }
                        }

                        .r {
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            width: calc(100% - 0.6em);
                            height: 100%;

                            &:hover {
                                .left,.right {
                                    display: block
                                }
                            }

                            .t {
                                display: flex;
                                width: 100%;
                                height: 0.64em;
                                overflow-x: clip;

                                ul {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    height: 0.64em;

                                    li {
                                        display: flex;
                                        flex-direction: row;
                                        align-items: center;
                                        width: 19.143em;
                                        height: 100%;
                                        line-height: 4.5714em;
                                        // text-align: center;
                                        padding: 0 1.786em;
                                        box-sizing: border-box;
                                        font-size: 0.14em;
                                        color: #FFF;

                                        i {
                                            display: block;
                                            min-width: 1.1429em;
                                            min-height: 1.1429em;
                                            background: url('../assets/img/timeVideo/prev.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            user-select: none;
                                            margin-right: 0.0714em;
                                        }

                                        span {
                                            text-overflow: ellipsis;
                                            overflow: hidden;
                                            white-space: nowrap;
                                        }

                                        &.live {
                                            i {
                                                display: block;
                                                min-width: 1.1429em;
                                                min-height: 1.1429em;
                                                background: url('../assets/img/timeVideo/nowlive.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                                user-select: none;
                                                margin-right: 0.0714em;
                                            }
                                        }

                                        &.next {
                                            i {
                                                display: block;
                                                min-width: 1.1429em;
                                                min-height: 1.1429em;
                                                background: url('../assets/img/timeVideo/unplay.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                                user-select: none;
                                                margin-right: 0.0714em;
                                            }
                                        }
                                        
                                        &.on {
                                            background: linear-gradient(180deg, rgba(58, 255, 203, 0) 0%, rgba(82, 255, 204, 0.1) 43%, rgba(26, 255, 175, 0.8) 100%);
                                        }
                                    }
                                }
                            }

                            .left {
                                display: none;
                                position: absolute;
                                top: 50%;
                                left: 0.06em;
                                width: 0.24em;
                                height: 0.24em;
                                margin-top: -0.12em;
                                background: url('../assets/img/timeVideo/left.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }

                            .right {
                                display: none;
                                position: absolute;
                                top: 50%;
                                right: 0.06em;
                                width: 0.24em;
                                height: 0.24em;
                                margin-top: -0.12em;
                                background: url('../assets/img/timeVideo/right.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }

                            .line {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                width: 100%;
                                height: 0.04em;
                                background: #41B48C;

                                &::after {
                                    position: absolute;
                                    top: 50%;
                                    right: 0;
                                    margin-top: -0.06em;
                                    display: block;
                                    content: '';
                                    width: 0.12em;
                                    height: 0.12em;
                                    border-radius: 50%;
                                    background: #FFFFFF;
                                    box-shadow: -5px 1px 8px 0px rgba(20, 117, 83, 0.44);
                                }
                            }

                            .t {
                                width: 100%;
                                height: 0.64em;
                            }

                            .b {
                                display: flex;
                                width: 100%;
                                height: 0.04em;
                                background: rgba(255,255,255,0.2);
                                overflow-x: clip;

                                ul {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    transform: translateX(0px);

                                    li {
                                        position: relative;
                                        width: 2.67em;
                                        height: 0.04em;
                                        // background: #41B48C;

                                        span {
                                            position: absolute;
                                            left: 0.462em;
                                            bottom: -1.6154em;
                                            font-size: 0.13em;
                                            color: #FFF;
                                            // font-weight: bold;
                                        }

                                        &::after {
                                            position: absolute;
                                            bottom: -0.18em;
                                            left: 0px;
                                            display: block;
                                            content: '';
                                            width: 1px;
                                            height: 0.18em;
                                            background: rgba(255,255,255,0.3);
                                            cursor: pointer;
                                            // background: red;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .bottom-container {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: flex-end;
                        width: 100%;
                        height: 0.72em;
                        padding: 0 0.24em 0.14em;
                        box-sizing: border-box;
                        user-select: none;

                        &.live {
                            height: 0.52em;
                            padding: 0.14em 0.24em;
                            box-sizing: border-box;
                        }

                        .l {
                            i {
                                display: block;
                                width: 24px;
                                height: 24px;
                                background: url('../assets/img/timeVideo/play.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;

                                &.pause {
                                    display: block;
                                    width: 24px;
                                    height: 24px;
                                    background: url('../assets/img/timeVideo/pause.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        

                        .r {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            .time {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                margin-right: 0.24em;

                                p {
                                    font-size: 0.14em;
                                    color: #FFF;
                                    line-height: 1.429em;
                                }

                                div {
                                    display: flex;
                                    align-items: center;
                                    width: 0.3em;
                                    height: 0.14em;
                                    background: #41B48C;
                                    border-radius: 0.07em;
                                    margin-left: 0.1em;
                                    user-select: none;
                                    cursor: pointer;

                                    &.un {
                                        background: #CED3D7;

                                        i {
                                        margin-left: 0.01em;
                                        transition: margin-left 0.3s;
                                        }
                                    }

                                    i {
                                        display: block;
                                        width: 0.12em;
                                        height: 0.12em;
                                        background: #FFFFFF;
                                        border-radius: 50%;
                                        margin-left: 0.17em;
                                        transition: margin-left 0.3s;
                                    }
                                }
                            }

                            .vol {
                                position: relative;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 0.24em;
                                height: 0.24em;
                                margin-right: 0.24em;
                                user-select: none;
                                cursor: pointer;

                                // &:hover {
                                //     i {
                                //         display: block !important;
                                //         width: 100%;
                                //         height: 100%;
                                //         background: url('../assets/img/timeVideo/volOn.png') no-repeat;
                                //         background-size: 100% 100%;
                                //         background-position: center center;
                                //     }
                                // }

                                i {
                                    display: block !important;
                                    width: 100%;
                                    height: 100%;
                                    background: url('../assets/img/timeVideo/vol.png') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                }

                                .volContent {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    align-items: center;
                                    position: absolute;
                                    bottom: 0.3em;
                                    left: 50%;
                                    width: 0.42em;
                                    height: 1.48em;
                                    margin-left: -0.21em;
                                    padding: 0.1em 0;
                                    background: #1F2128;
                                    box-shadow: 0.04em 0.04em 0.1em 0px rgba(5, 10, 15, 0.05);
                                    box-sizing: border-box;

                                    .line {
                                        position: relative;
                                        width: 0.02em;
                                        height: 1em;

                                        .lineProgress {
                                            width: 0.02em;
                                            height: 1em;
                                            background: rgba(80, 85, 88, 0.29);
                                            border-radius: 0.05em;
                                        }

                                        .lineCover {
                                            position: absolute;
                                            bottom: 0;
                                            left: 0;
                                            width: 100%;
                                            height: 100%;
                                            background: #41B48C;

                                            i {
                                                position: absolute;
                                                top: -0.04em;
                                                left: -0.05em;
                                                display: block;
                                                width: 0.12em;
                                                height: 0.12em;
                                                border-radius: 50%;
                                                background: #41B48C;
                                                user-select: none;
                                                cursor: pointer;
                                            }
                                        }
                                    }

                                    & > p {
                                        font-size: 0.13em;
                                        font-weight: 500;
                                        color: #FFF;
                                        line-height: 1.3846em;
                                    }

                                    &::after {
                                        position: absolute;
                                        left: 50%;
                                        bottom: -0.06em;
                                        margin-left: -0.05em;
                                        display: block;
                                        content: '';
                                        width: 0;
                                        height: 0;
                                        border-left: 0.06em solid transparent;
                                        border-right: 0.06em solid transparent;
                                        border-top: 0.06em solid #1F2128;
                                    }
                                }
                            }

                            .large {
                                display: block;
                                width: 0.24em;
                                height: 0.24em;
                                background: url('../assets/img/timeVideo/large.png') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                user-select: none;
                                cursor: pointer;
                            }
                        }
                    }
                }
        }
    }
</style>

<style lang="less">
    .timeVideo-container {
        .el-picker-panel {
            background: #1F2128;
            color: rgba(255, 255, 255, 0.65);
        }

        .el-date-editor {
            user-select: none;
            cursor: pointer;
        }

        .el-input__inner,.el-input__prefix {
            background: transparent;
            color: transparent;
            border: none;
            user-select: none;
            cursor: pointer;

            &::placeholder {
                color: transparent;
            }
        }

        .el-input__prefix {
            display: none;
        }

        .el-input__suffix {
            display: none;
        }
    }
    
    .timeVideo ~ .el-picker-panel {
        background: #1F2128 !important;
        // color: rgba(255, 255, 255, 0.65) !important;

        .el-date-table th {
            color: rgba(255, 255, 255, 0.85);
            text-shadow: 0px 12px 48px rgba(0, 0, 0, 0.09);
            border-bottom: 1px solid rgba(255, 255, 255, 0.12);
            box-sizing: border-box;
            box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.09);
        }

        .el-date-table td.current:not(.disabled) span {
            color: #FFF !important;
        }

        .el-date-table td.next-month, .el-date-table td.prev-month {
            color: rgba(255, 255, 255, 0.25);
        }



        .today {
            &.current {
                &::after {
                    display: none;
                }
            }
            &::after {
                position: absolute;
                left: 50%;
                margin-left: -2px;
                display: block;
                content: '';
                width: 4px;
                height: 4px;
                background: #41B48C;
                border-radius: 50%;
                box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.09);
            }
        }

        .available {
            color: rgba(255, 255, 255, 0.65);
        }

        .el-date-picker__header-label {
            color: rgba(255, 255, 255, 0.85);
        }

        .el-picker-panel__icon-btn {
            color: rgba(255, 255, 255, 0.65);
        }

        .el-date-table td.disabled div {
            background-color: rgba(245,247,250,0.2)
        }

        .el-year-table td.today .cell {
            color: #41B48C;

            &:hover {
                color: #41B48C
            }
        }

        .el-year-table td .cell:hover {
            color: #41B48C
        }

        .el-year-table td.disabled .cell {
            background-color: rgba(245,247,250,0.2)
        }

        .el-month-table td.today .cell {
            color: #41B48C;

            &:hover {
                color: #41B48C
            }
        }

        .el-month-table td .cell:hover {
            color: #41B48C
        }

        .el-month-table td.disabled .cell {
            background-color: rgba(245,247,250,0.2)
        }
    }

</style>